import { SkeletonLoading } from '@app/shared';
import { declensionFactory } from '@helpers/declension';
import { useGetStateProduct } from '@entities/Catalog';
import classNames from 'classnames';

import styles from './CountProduct.module.scss';

const value = declensionFactory('товар', 'товара', 'товаров');
const modelsValue = declensionFactory('модель', 'модели', 'моделей');

interface ICountProps {
  className?: string;
  dataTestId?: string;
}

export const CountProduct = ({ className, dataTestId }: ICountProps) => {
  const { productFetching, modelsFetching, totalCount, isModels } = useGetStateProduct();

  if (productFetching || modelsFetching) {
    return <SkeletonLoading width={'150px'} height={'18px'} />;
  }

  if (!totalCount) {
    return null;
  }

  return (
    <div data-testid={dataTestId} className={classNames(styles.TotalCountProduct, className)}>
      {totalCount} {isModels ? modelsValue(totalCount) : value(totalCount)}
    </div>
  );
};
